//#region src/auth/util.ts
function extractAuthToken(obj) {
	return obj.authentication.dashboard;
}

//#endregion
export { extractAuthToken };